<template>
  <div v-if="currentNomenclature">
    <div class="row">
      <div class="col-md-6">
        <BreadCrumd
          :title="'Nomenclatures'"
          :description="'Aperçu d\'une nomenclature'"
        />
      </div>
      <div class="col-md-6 mt-4">
        <div class="row" v-if="selectedProduit">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex">
                  <td class="col-12 text-center font-weight-bold">
                    Produit concerné
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-8 text-custom-primary">
                    Désignation : {{ selectedProduit.designation }}
                  </td>
                  <td class="col-4 text-custom-primary">
                    Référence : {{ selectedProduit.reference }}
                  </td>
                </tr>
                <tr class="d-flex">
                  <td class="col-6 font-weight-bold">
                    Type : {{ selectedProduit.type }}
                  </td>
                  <td class="col-6 font-weight-bold">
                    Stock :
                    {{ selectedProduit.stock + ' ' + selectedProduit.unite }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_nomenclature' }).catch(() => {})
          "
        >
          Liste des nomenclatures
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router.push({ name: 'gpao_nomenclature-create' }).catch(() => {})
          "
        >
          <i :class="show.ICON_PLUS"></i>
          Nouvelle nomenclature
        </button>

        <button
          type="button"
          title="Transformer en collecte de prix"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({ name: 'gpao_nomenclature-edit', params: { id: id } })
              .catch(() => {})
          "
        >
          <i :class="show.ICON_EDIT" class="font-size-17"></i> Modifier
        </button>
      </div>
    </div>

    <div class="mt-4 mb-4">
      <div class="row">
        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Libellé </span>
                  </td>
                  <td>{{ currentNomenclature.libelle }}</td>
                </tr>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Quantité min</span>
                  </td>
                  <td>
                    {{
                      currentNomenclature.quantite_min +
                      ' ' +
                      selectedProduit.unite
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td class="text-primary">
                    {{
                      currentNomenclature.created_by.prenom
                        ? currentNomenclature.created_by.prenom +
                          ' ' +
                          currentNomenclature.created_by.nom
                        : currentNomenclature.created_by.nom
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mt-n4 mt-lg-0 col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Quantité de référence</span>
                  </td>
                  <td>
                    {{
                      currentNomenclature.quantite_reference +
                      ' ' +
                      selectedProduit.unite
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i
                      :class="show.ICON_INFO_CIRCLE"
                      class="text-custom-primary"
                    ></i>
                    <span class="font-weight-bold"> Statut</span>
                  </td>
                  <td>
                    <b-badge
                      variant="custom-primary"
                      pill
                      v-if="currentNomenclature.statut"
                      class="p-2"
                    >
                      Actif
                    </b-badge>
                    <b-badge variant="danger" pill v-else class="p-2">
                      Inactif
                    </b-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-if="selectedProduit">
        <div class="row mt-n4">
          <div class="col-lg-12">
            <div role="tablist">
              <b-card
                no-body
                class="mb-2"
                v-for="(item, index) in currentNomenclature.item_lists"
                :key="index"
              >
                <b-card-header
                  header-tag="header"
                  role="tab"
                  v-b-toggle="'accordion-' + (index + 1)"
                  header-class="bg-silver"
                >
                  <span class="when-open">
                    <h6 class="m-0">
                      <a class="text-dark" href="javascript: void(0);">{{
                        item.libelle
                          ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                          : 'Etape ' + (index + 1)
                      }}</a>
                      <span class="accicon">
                        <i :class="show.ICON_ANGLE_UP"></i>
                      </span>
                    </h6>
                  </span>
                  <span class="when-closed">
                    <h6 class="m-0">
                      <a class="text-dark" href="javascript: void(0);">{{
                        item.libelle
                          ? 'Etape ' + (index + 1) + ' : ' + item.libelle
                          : 'Etape ' + (index + 1)
                      }}</a>
                      <span class="accicon">
                        <i :class="show.ICON_ANGLE_DOWN"></i>
                      </span>
                    </h6>
                  </span>
                </b-card-header>
                <b-collapse
                  style="background-color: #f3f3f3"
                  :id="'accordion-' + (index + 1)"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <div class="row mb-n4 mt-0">
                    <div class="col-12">
                      <div class="card">
                        <table class="table table-sm table-bordered">
                          <thead>
                            <tr>
                              <th scope="col">Libellé</th>
                              <th scope="col">Poste de charge</th>
                              <th scope="col">Nature étape</th>
                              <th scope="col">Checklist</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ item.libelle }}</td>
                              <td>{{ item.poste_charge.nom }}</td>
                              <td>
                                <b-badge variant="primary" v-if="item.debut"
                                  >Début</b-badge
                                >
                                <b-badge
                                  variant="success"
                                  class="ml-1"
                                  v-if="item.fin"
                                  >Fin</b-badge
                                >
                                <b-badge
                                  variant="primary"
                                  class="ml-1"
                                  v-if="!item.debut && !item.fin"
                                  >Intermediaire</b-badge
                                >
                              </td>
                              <td>
                                <b-badge
                                  variant="primary"
                                  v-for="(
                                    checklist, indexC
                                  ) in item.selected_checklists"
                                  :key="indexC"
                                  >{{ checklist.nom }}</b-badge
                                >
                                <b-badge
                                  variant="primary"
                                  class="ml-1"
                                  v-if="item.selected_checklists.length === 0"
                                  >Pas de checklists</b-badge
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-n2 mb-n4">
                    <div class="col-md-12 col-lg-6">
                      <b-card
                        no-body
                        class="text-black"
                        header-class="bg-silver"
                      >
                        <template v-slot:header>
                          <div class="row">
                            <div class="col-md-12 text-lg-left text-center">
                              <span class="font-weight-bold"
                                >Consommation des matières premières</span
                              >
                            </div>
                          </div>
                        </template>
                        <div class="row">
                          <div class="col-12">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col">Désignation</th>
                                  <th scope="col">Référence</th>
                                  <th scope="col">Quantité</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(article, index3) in item.matieres"
                                  :key="index3"
                                >
                                  <th scope="row">{{ index3 + 1 }}</th>
                                  <td>
                                    {{ article.designation }}
                                  </td>
                                  <td>{{ article.reference }}</td>
                                  <td>
                                    {{ article.quantite + ' ' + article.unite }}
                                  </td>
                                </tr>

                                <tr v-if="item.matieres.length === 0">
                                  <td class="text-center" colspan="4">
                                    Aucune donnée
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </b-card>
                    </div>
                    <div class="col-md-12 col-lg-6">
                      <b-card
                        no-body
                        class="text-black"
                        header-class="bg-silver"
                      >
                        <template v-slot:header>
                          <div
                            class="row"
                            v-if="
                              lastItem &&
                              lastItem.identifiant === item.identifiant
                            "
                          >
                            <div class="col-md-12 text-md-left text-center">
                              <span class="font-weight-bold"
                                >Produit fini à fabriquer
                              </span>
                            </div>
                          </div>
                          <div class="row" v-else>
                            <div class="col-md-12 text-lg-left text-center">
                              <span class="font-weight-bold"
                                >Produits semi-finis à fabriquer
                              </span>
                            </div>
                          </div>
                        </template>
                        <div class="row">
                          <div class="col-12">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col">Désignation</th>
                                  <th scope="col">Référence</th>
                                  <th scope="col">Quantité</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(article, index3) in item.produits"
                                  :key="index3"
                                >
                                  <th scope="row">{{ index3 + 1 }}</th>
                                  <td>
                                    {{ article.designation }}
                                  </td>
                                  <td>{{ article.reference }}</td>
                                  <td>
                                    {{ article.quantite + ' ' + article.unite }}
                                  </td>
                                </tr>

                                <tr v-if="item.produits.length === 0">
                                  <td class="text-center" colspan="4">
                                    Aucune donnée
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </b-card>
                    </div>
                  </div>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/gpao/nomenclature';
import { show } from '@/icons/gpao/nomenclature';
export default {
  data() {
    return {
      show,

      currentNomenclature: null,
      selectedProduit: null,
      title: 'Gestion des nomenclatures - Aperçu',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    firstItem() {
      return (
        this.currentNomenclature.item_lists.find(
          (item) => item.debut === true
        ) || null
      );
    },
    lastItem() {
      return (
        this.currentNomenclature.item_lists.find((item) => item.fin === true) ||
        null
      );
    },
  },
  methods: {
    init() {
      this.id = this.$route.params.id;
      this.currentNomenclature = null;
      this.selectedProduit = null;

      window.axios
        .get(URL.NOMENCLATURE + '/' + this.id)
        .then((resp) => {
          this.currentNomenclature = resp.data.nomenclature;
          this.selectedProduit = this.currentNomenclature.produit;
          delete this.currentNomenclature.produit;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
